import moment from "moment";
import { capitalizeMessage } from "./utils";

export default {
    install(Vue) {
        Vue.filter("DATE", (date, format="YYYY-MM-DD", isUnix) => {
            try {
                return isUnix ?
                    moment.unix(date).format(format) :
                    moment(date).format(format);
            } catch {
                return date;
            }
        });
        Vue.filter('CURRENCY', (value) => {
            try {
                if (typeof value !== "number") {
                    return value;
                }
                const formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 0
                });
                return formatter.format(value);
            } catch {
                return value;
            }
        });
        Vue.filter('MESSAGE', (value) => {
            return capitalizeMessage(value);
        });
    }
};